import { CallApi, handleJSONResponse } from "./common";
import { RespMacros } from "../../../../services/macros/types/macros-response";
import { Macro } from "../../../../services/macros/types/macros";

const callAPI = CallApi("macros");

export const listMacros = async (): Promise<RespMacros> => {
  const response = await callAPI(`/list`, "GET");

  return handleJSONResponse(response);
};

export const createMacro = async (
  payload: Omit<Macro, "id">
): Promise<Macro> => {
  const response = await callAPI(`/`, "POST", payload);

  return handleJSONResponse(response);
};

export const updateMacro = async (
  id: string,
  payload: Omit<Macro, "id">
): Promise<Macro> => {
  const response = await callAPI(`/${id}`, "PUT", payload);

  return handleJSONResponse(response);
};

export const deleteMacro = async (id: string) => {
  return callAPI(`/${id}`, "DELETE");
};
